import { css, styled } from '@mui/material/styles';
import { Box as BoxMUI } from '@mui/material';

interface CardMeetingProps {
  status: Date | undefined;
}

export const CardMeeting = styled(BoxMUI)`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 10px 20px;
  gap: 15px;
  height: 90px;
  width: 100%;
  border-radius: 6px;
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.1);
  border: 1px solid #bdbdbd;

  & + div {
    margin-top: 20px;
  }

  ${(props: CardMeetingProps) =>
    props.status !== null &&
    css`
      border-color: red;
    `}

  .desc-meeting {
    display: flex;
    flex-direction: column;
    list-style: none;
    gap: 3px;
  }

  h3 {
    margin: 0;
  }

  .day-meeting {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    font-size: 52px;
    line-height: 22px;
    display: flex;
    align-items: center;
    letter-spacing: 0.15px;
  }

  .date-meeting {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    justify-content: center;
    height: 100%;
    width: 124px;
    padding: 0;
    margin: 0;
    gap: 10px;
    border-right: 1px solid #d0d0d0;
    padding-right: 20px;
  }

  .month-meeting {
    font-style: normal;
    font-weight: 400;
    font-size: 23px;
    line-height: 24px;
    color: ${({ theme }) => theme.palette.primary.dark};
  }

  .duration-meeting {
    font-family: 'Montserrat';
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 16px;
    display: flex;
    align-items: center;
    text-align: center;
    flex-direction: row;
    color: #9e9e9e;
  }

  .title {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    color: #000000;
  }
`;

export const Div = styled(BoxMUI)`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 530px;
  height: 100%;
  gap: 20px;
`;

export const Status = styled(BoxMUI)`
  text-decoration: none;
  padding: 0;
  margin: 0;
  color: #ffffff;
  border-radius: 50px;
  width: fit-content;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 4px 10px;
  height: 28px;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  letter-spacing: 0.15px;
`;
